import { useTranslation } from 'react-i18next';
import { AccessLevel } from 'lavva.exalushome/build/js/Services/Users/IUser';
import { IconLavva } from '../../../assets/icons';
import {
  IconActions,
  IconChat,
  IconDashboard,
  IconDeviceList,
  IconProfile,
  IconWidgets,
} from '../../../assets/navigation-icons';
import { useInstallationContext } from '../../../context/installation';
import { IntegrationType } from '../../../data-access/gql-types/graphql';
import { environment } from '../../../environment';
import { useLoggedUser } from '../../../integrations/exalus/hooks/common/logged-user';
import { ROUTES } from '../../../routes/routes';
import { IntegrationDefaultEnum } from '../../../types';
import { isWisniowski } from '../../../utils/helpers';
import { BottomNavigationLink } from '../types/types';

export const useBottomNavigation = () => {
  const { t } = useTranslation('common');
  const { integrationType } = useInstallationContext();
  const { hasAccessToScenarios, user: exalusUser } = useLoggedUser();
  const isExalus = integrationType === IntegrationType.Exalus;
  const dashboardVisible = !isExalus && !isWisniowski;

  const getLinks = (): BottomNavigationLink[] => {
    switch (integrationType) {
      case IntegrationType.Exalus: {
        return [
          { href: ROUTES.Root(), Icon: IconDashboard, title: t('navigation.groups') },
          {
            href: ROUTES.Channel(),
            Icon: IconDeviceList,
            title: t('navigation.channels'),
          },
          ...(exalusUser?.AccessLevel !== AccessLevel.Guest
            ? [
                {
                  href: ROUTES.Chat(),
                  Icon: IconChat,
                  title: t('navigation.chat'),
                },
              ]
            : []),
          ...(hasAccessToScenarios
            ? [
                {
                  href: ROUTES.ActionList(),
                  Icon: IconActions,
                  title: t('navigation.actions'),
                },
                {
                  href: ROUTES.Settings(),
                  Icon: IconProfile,
                  title: t('navigation.settings'),
                },
              ]
            : []),
        ];
      }
      case IntegrationType.Lavva: {
        return [
          {
            href: ROUTES.Root(),
            Icon: IconDashboard,
            title: t('navigation.groups'),
          },
          {
            href: ROUTES.Channel(),
            Icon: IconDeviceList,
            title: t('navigation.channels'),
          },
          ...(dashboardVisible
            ? [
                {
                  href: ROUTES.Dashboard(),
                  Icon: environment.INTEGRATION_DEFAULT === IntegrationDefaultEnum.Lavva ? IconLavva : IconWidgets,
                  title: '',
                  preference: true,
                },
              ]
            : []),
          ...(integrationType === IntegrationType.Lavva
            ? [
                {
                  href: ROUTES.ActionList(),
                  Icon: IconActions,
                  title: t('navigation.actions'),
                },
              ]
            : []),
          {
            href: ROUTES.Settings(),
            Icon: IconProfile,
            title: t('navigation.settings'),
          },
        ];
      }
      default: {
        return [
          {
            href: ROUTES.Root(),
            Icon: IconDashboard,
            title: t('navigation.groups'),
          },
          {
            href: ROUTES.Channel(),
            Icon: IconDeviceList,
            title: t('navigation.channels'),
          },
          {
            href: ROUTES.Settings(),
            Icon: IconProfile,
            title: t('navigation.settings'),
          },
        ];
      }
    }
  };

  const links = getLinks();

  return {
    links,
  };
};
